<dgx-modal
  *ngIf="initialized"
  bodyClasses="guts-p-t-0"
  [canCancel]="true"
  [isHeaderBorderless]="false"
  [isPendingWithOverlay]="true"
  [useDefaultForm]="false"
  [useDefaultSubmitButton]="false"
>
  <ng-container class="modal-header">
    {{ i18n.TargetResourcesForm_Title }}
  </ng-container>
  <ng-container class="modal-body">
    <div id="a11y-keywatch" class="dropdown-menu__min-height">
      <div class="grid">
        <div class="grid__col-12">
          <p
            class="par par--light par--small guts-p-b-1"
            *ngIf="resourceSection.resourceType === 'Input'"
            [textContent]="i18n.TargetResourcesForm_InputHelp"
          ></p>

          <div
            ngbDropdown
            [open]="suggestions.length > 0 && showSuggestions"
            dropdownClass="dropdown-menu--borders"
          >
            <dgx-search-field-wrapper>
              <input
                #searchInput
                class="js-suggestion-input"
                type="text"
                data-dgat="target-resources-modal-ed4"
                [placeholder]="i18n.TargetResourcesForm_SearchPlaceHolder"
                [attr.aria-label]="i18n.TargetResourcesForm_SearchPlaceHolder"
                [(ngModel)]="term"
                [value]="term"
                [dgxAutofocus]
                (focus)="onSearchFocus()"
                autocomplete="off"
                data-dgat="targetResourcesForm-04a"
                role="combobox"
                aria-autocomplete="list"
              />
            </dgx-search-field-wrapper>
          </div>

          <!-- Suggestions found -->
          <div
            ngbDropDown
            #ngbDropdown
            class="dropdown dropdown-menu--borders"
            *ngIf="suggestions.length > 0"
          >
            <div
              class="
                dropdown-menu
                typeahead-popup
                dropdown-menu__arrow
                guts-m-t-1
              "
              role="menu"
              [attr.a11y-is-open]="showSuggestions"
              [class.dropdown-menu--open]="showSuggestions"
            >
              <ng-container *ngIf="!isSkillRegistryEnabled">
                <h1
                  *ngIf="showSuggestionsHeader"
                  class="h4 guts-m-h-1 guts-m-t-1"
                  [textContent]="i18n.TargetResourcesForm_Suggestions"
                ></h1>
              </ng-container>
              <ul class="typeahead-list js-suggestion-list">
                <li
                  ngbDropdownItem
                  *ngIf="showCreatePlanButton"
                  class="typeahead-item"
                >
                  <button
                    df-button
                    dfButtonType="clear"
                    class="
                      color-blue
                      font-semibold
                      guts-p-l-0 guts-p-b-1
                      js-suggestion-focus
                      dropdown-item
                    "
                    role="menuitem"
                    data-dgat="targetResourcesForm-a77"
                    (click)="createAPlan()"
                  >
                    <df-icon icon="plus-circle" class="guts-m-h-2"></df-icon>
                    <span [textContent]="createAPlanLabel"></span>
                  </button>
                </li>
                <li
                  *ngFor="let suggestion of suggestions"
                  class="typeahead-item js-suggestion-item"
                  data-dgat="targetResourcesForm-29c"
                  role="menuitem"
                >
                  <a
                    tabindex="0"
                    href=""
                    (click)="add($event, suggestion)"
                    (keydown)="suggestionKeydown($event, suggestion)"
                    class="guts-p-full-0 js-suggestion-focus"
                    data-dgat="targetResourcesForm-3ee"
                  >
                    <dgx-target-resource-list-item
                      [item]="suggestion"
                    ></dgx-target-resource-list-item>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- Dropdown for no results, with option for create a plan/directory or create a custom tag, depending on circumstance -->
          <div
            ngbDropdown
            class="dropdown dropdown-menu--borders"
            *ngIf="!showSuggestions && noResults && !!term"
            [open]="!showSuggestions && noResults"
          >
            <div
              class="
                dropdown-menu dropdown-menu--open
                typeahead-popup
                dropdown-menu__arrow
                guts-m-t-1
              "
              role="menu"
              [attr.a11y-is-open]="!showSuggestions && noResults"
              a11y-focus-first="false"
            >
              <ul class="typeahead-list js-suggestion-list">
                <li
                  *ngIf="resourceSection.resourceType !== 'Tag'"
                  class="guts-p-l-2 guts-p-v-1"
                >
                  <p
                    class="color-ebony-a61 par par--small font-medium"
                    [textContent]="i18n.TargetResourcesForm_NoResultsFound"
                  ></p>
                </li>
                <li
                  *ngIf="showCreatePlanButton"
                  class="guts-p-t-half border-top"
                >
                  <button
                    class="
                      color-blue
                      font-semibold
                      guts-p-l-0
                      par par--small
                      js-modal-close-btn
                    "
                    (click)="createAPlan()"
                    data-dgat="targetResourcesForm-1dc"
                  >
                    <df-icon icon="plus-circle" class="guts-m-h-2"></df-icon>
                    <span [textContent]="createAPlanLabel"></span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Selected items list -->
        <div class="grid__col-12" *ngIf="selectedSearchResults.length > 0">
          <dgx-org-managed-notification
            class="guts-m-b-2 block"
            *ngIf="showOrgManagedNotification"
            resourceType="Target"
          ></dgx-org-managed-notification>
          <h2
            class="h4 guts-p-b-half border-bottom"
            [textContent]="i18n.TargetResourcesForm_Selected"
          ></h2>
          <ul>
            <li *ngIf="showCreatePlanButton" class="border-bottom guts-p-v-1">
              <button
                class="
                  color-blue
                  font-semibold
                  guts-p-l-0
                  par par--small
                  js-modal-close-btn
                "
                data-dgat="targetResourcesForm-a77"
                (click)="createAPlan()"
              >
                <df-icon icon="plus-circle" class="guts-m-h-2"></df-icon>
                <span [textContent]="createAPlanLabel"></span>
              </button>
            </li>
            <li
              *ngFor="let item of selectedSearchResults; let i = index"
              data-dgat="targetResourcesForm-cae"
            >
              <div class="l_flexbar border-bottom">
                <div class="l_flex-grow">
                  <dgx-target-resource-list-item
                    [item]="item"
                  ></dgx-target-resource-list-item>
                </div>
                <div>
                  <button
                    df-button
                    dfButtonType="clear"
                    class="dg-modal__close-icon"
                    (click)="remove(i)"
                    [ngbTooltip]="i18n.Core_Remove"
                    tooltip-trigger="'focus mouseenter'"
                    [attr.aria-label]="i18n.Core_Remove"
                    data-dgat="targetResourcesForm-699"
                  >
                    <df-icon icon="cross" size="medium"></df-icon>
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <!-- Option to create a new directory or plan. Only shows in center of modal if no items have been selected yet -->
        <div
          *ngIf="!selectedSearchResults.length && showCreatePlanButton"
          class="grid__col-12 center-item center-text guts-p-t-9"
        >
          <p
            class="par par--light par--small"
            [textContent]="noItemsSelected"
          ></p>
          <button
            class="
              par par--small
              color-blue
              font-semibold
              guts-m-full-1
              js-modal-close-btn
              l_flexbar l_flex-center
            "
            data-dgat="targetResourcesForm-a77"
            (click)="createAPlan()"
          >
            <df-icon icon="plus-circle" class="guts-m-r-half"></df-icon>
            <span [textContent]="createAPlanLabel"></span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container class="modal-footer">
    <button
      type="submit"
      df-button
      dfButtonType="primary"
      [class.is_disabled]="saving || selectedSearchResults.length === 0"
      [disabled]="saving || selectedSearchResults.length === 0"
      (click)="save()"
      [textContent]="saving ? i18n.Core_Saving : i18n.TargetResourcesForm_Title"
      data-dgat="targetResourcesForm-c4a"
    ></button>
  </ng-container>
</dgx-modal>
